import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import Markdown from '../ui/Markdown';

const Wrapper = styled.section`
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
  padding: 24px;
`;

const Title = styled.h1`
  margin: 0 0 24px;
`;

const Faq = () => {
  const { t } = useTranslation(['common']);

  return (
    <Wrapper>
      <Title>{t('common:informations.faq.label') || 'FAQ'}</Title>
      <Markdown>{t('common:informations.faq.content') || ''}</Markdown>
    </Wrapper>
  );
};

export default Faq;
